import { render } from "./CooperativeAgreement.vue?vue&type=template&id=4bbbc332&scoped=true"
import script from "./CooperativeAgreement.vue?vue&type=script&lang=js"
export * from "./CooperativeAgreement.vue?vue&type=script&lang=js"

import "./CooperativeAgreement.vue?vue&type=style&index=0&id=4bbbc332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbbc332"]])

export default __exports__